const config = {
  // baseURL : 'https://api.realcloud.uwss.kr/v1',
  // baseSignalR : 'https://api.realcloud.uwss.kr',

  // baseURL : 'http://localhost:5001/v1',
  // baseSignalR : 'http://localhost:5001',

  // baseURL : 'https://api.f1secaas.co.kr/v1',
  // baseSignalR : 'https://ws.f1secaas.co.kr',

  baseURL : 'https://api.f1secaas.net/v1',
  baseSignalR : 'https://ws.f1secaas.net',

  // baseURL : 'https://api.uwss.jp/v1',
  // baseSignalR : 'https://ws.uwss.jp',

  // baseURL : 'http://localhost:5001/v1',
  // baseSignalR : 'http://localhost:5001',
  // baseURL : 'https://api.azure.uwss.kr/v1',
  // baseSignalR : 'https://api.azure.uwss.kr',
  manual : "f1-uwss.en.front.manual.latest.pdf",
  version : "2022.05",
  wsfinder_version : '2022.05',
  webcastle_version : '2022.05',
  webcastle_version_mmdb : '2022.08',
}

export default config;

